import React, { useEffect } from 'react';

import Icon from 'components/DesignSystem/Icon';
import Slider from 'components/DesignSystem/Slider';
import DoubleSlider from 'components/DesignSystem/Slider/DoubleSlider';
import useNumericForecastControlPanel from 'utils/hooks/meteorology/useNumericForecastControlPanel';
import useMaxOffset from 'utils/hooks/meteorology/numericForecast/useMaxOffset';
import useSliderProps from 'utils/hooks/meteorology/numericForecast/useSliderProps';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function ForecastDaysRange() {
  const {
    period,
    forecastDateIndex: dateOffset,
    setDateIndex,
  } = useNumericForecastControlPanel();
  const maxValue = useMaxOffset();
  const minValue = ['d', 'p'].includes(period?.at(0)) ? 1 : 0;
  const {
    sliderClassName,
    sliderMax,
    sliderMin,
    sliderValue,
    sliderMinDistance,
    sliderOnChange,
  } = useSliderProps(maxValue, minValue, dateOffset, period);

  useEffect(() => {
    if ((dateOffset ?? 0) < minValue) {
      setDateIndex(minValue);
    }
  });

  return (
    <div className="tf-pnt-mobile-days-range">
      <button type="button" aria-label="Primeiro dia" className="tf-pnt-mobile-days-range-button" onClick={() => setDateIndex(minValue)}>
        <Icon iconType="double_left_arrow" color={cssVar('text-accent')} size="small" />
      </button>
      <button type="button" aria-label="Dia anterior" className="tf-pnt-mobile-days-range-button" onClick={() => setDateIndex(Math.max((dateOffset ?? 0) - 1, minValue))}>
        <Icon iconType="left_arrow" color={cssVar('text-accent')} size="small" />
      </button>
      {sliderClassName === 'pentad-slider' && (
        <DoubleSlider
          max={sliderMax}
          min={sliderMin}
          value={sliderValue as number[]}
          setValue={sliderOnChange as (value: number[]) => void}
          minDistance={sliderMinDistance || 1}
          className={sliderClassName}
        />
      )}
      {sliderClassName === 'horizontal-slider' && (
        <Slider
          max={sliderMax}
          min={sliderMin}
          value={sliderValue as number}
          setValue={sliderOnChange as (value: number) => void}
          className={sliderClassName}
        />
      )}
      <button type="button" aria-label="Próximo dia" className="tf-pnt-mobile-days-range-button" onClick={() => setDateIndex(Math.min((dateOffset ?? 0) + 1, maxValue))}>
        <Icon iconType="right_arrow" color={cssVar('text-accent')} size="small" />
      </button>
      <button type="button" aria-label="Último dia" className="tf-pnt-mobile-days-range-button" onClick={() => setDateIndex(maxValue)}>
        <Icon iconType="double_right_arrow" color={cssVar('text-accent')} size="small" />
      </button>
    </div>
  );
}
